import { Text } from '@brokerbay/elements-web';
import { Button, InputTextArea } from 'components';
import React, { useContext } from 'react';
import CoopSelectContext from '../CoopSelectContext';
import HiddenViewMlsLink from './HiddenViewMlsLink';

const Notes: React.FC = () => {
  const { setApptNote, showNote, setShowNote } = useContext(CoopSelectContext);

  if (showNote)
    return (
      <div>
        <Text>Notes</Text>
        <HiddenViewMlsLink />
        <InputTextArea
          data-cy="inPersonShowing-edit-note"
          onBlur={e => setApptNote(e.target.value)}
        />
      </div>
    );

  return (
    <div>
      <Button
        data-cy="inPersonShowing-addNote-btn"
        onClick={() => setShowNote(true)}
      >
        Add Note
      </Button>
      <HiddenViewMlsLink />
    </div>
  );
};

export default Notes;
